<script>
import { Inertia } from '@inertiajs/inertia'
import Edit from './edit.vue'

export default {
  extends: Edit,

  data() {
    return {
      ...Edit.data.call(this),
      title: 'Options :: Add Option',
    }
  },

  methods: {
    submit() {
      Inertia.post(this.$route('options.store'), this.form)
    },
  },
}
</script>
